import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import "firebase/auth";

import Page from "../shared/Page";
import * as authActions from "../../actions/authActions";
import Loader from "../ui/Loader";

class LogoutPage extends Component {
	componentDidMount = () => {
		this.props.authActions.logoutUser();
		//const { history } = this.props;
		//history.push("/");
	};
	render() {
		return (
			<Page title="Logout">
				<Loader />
				Logging Out
			</Page>
		);
	}
}
LogoutPage.propTypes = {
	authActions: PropTypes.object,
	history: PropTypes.array,
};
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
	return {
		authActions: bindActionCreators(authActions, dispatch),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LogoutPage);
